import React, { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Button from "app/components/CustomButtons/Button.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import axios from 'axios';
import { useLocation } from 'react-router';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { darkBlueColor } from 'app/layout/material-dashboard-react';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import SeaQuoteSummary from "app/components/Summary/SeaQuoteSummary.js";
import AirQuoteSummary from "app/components/Summary/AirQuoteSummary.js";
import WarningIcon from '@mui/icons-material/Warning';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import { LoginStatusContext } from 'app/context/LoginStatusContext';
import LoadingSpinner from '../Dashboard/LoadingSpinner';
import DeleteQuoteReason from 'app/components/Quote/DeleteQuoteReason';

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
};

const useStyles = makeStyles(styles);

//Format date string
function ProcessDate(date) {
    var shortDate = CreateShortDate(date);
    var requiredGBDate = shortDate.toLocaleDateString('en-GB');
    return requiredGBDate;
}

function CreateShortDate(date) {
    var shortDate = date.substring(0, date.indexOf('T'));
    var [YYYY, MM, DD] = shortDate.split('-');
    return new Date(YYYY, MM - 1, DD);
}

export default function ShipmentEdit() {
    const classes = useStyles();
    const [isTerminated, setIsTerminated] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showDeleteQuoteReason, setShowDeleteQuoteReason] = useState(false);
    const [deleteQuoteReasons, setDeleteQuoteReasons] = useState(false);
    const [quoteTerminationRequest, setQuoteTerminationRequest] = useState(null);
    const [quoteDetails, setQuoteDetails] = useState(undefined);
    const [quoteDetailsLoading, setQuoteDetailsLoading] = useState(true);
    const [showAcceptButton, setShowAcceptButton] = useState(false);
    const [showDeleteButton, setShowDeleteButton] = useState(false);

    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const { setIsLoggedIn } = useContext(LoginStatusContext);
    
    useEffect(() => {
        async function validateUserSessionId() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/login/ValidateUserSessionId`,)
                        .then(() => setIsLoggedIn(true));
                
            } catch (error) {
                setIsLoggedIn(false);
                window.location.replace(`${process.env.PUBLIC_URL}/login`);
            }
        }
        validateUserSessionId();
    }, [setIsLoggedIn]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/GetQuoteDetailsById`, { params: { shipmentID: params.get("shipmentId")} })
        .then((res) => {
            setQuoteDetails(res.data);
            setQuoteDetailsLoading(false);                            //Accept button
            if (res.data.totalCharge > 0  && !res.data.associatedShipmentRef) {
                setShowAcceptButton(true);
                setShowDeleteButton(false);
            }
            //Delete button
            if (res.data.totalCharge > 0 && res.data.attachments.some(q => q.documentTypeID === 26)) {
                setShowDeleteButton(true);
            }

            if (res.data.isTerminated) {
                setIsTerminated(true);
                setShowAcceptButton(false);
                setShowDeleteButton(false);
            }
        })
        .catch(error => console.error(`An error occured whilst getting quote details. Error: ${error.message}`))
    }, [params])

    const getDefaultStackMultiplier = (stackMultiplier) => {
        if (stackMultiplier === 2) {
            return "Yes";
        }

        return "No";
    };

    const terminateQuote = () => {
        axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/shipmentquote/TerminateQuote`, quoteTerminationRequest)
            .then(() => {
                setIsTerminated(true);
            })
            .catch((error) => console.error(`An error occured whilst trying to terminate quote with the error: ${error}`));
    }

    const convertQuoteToShipment = () => {
        const shipmentToQuoteReq =
        {
            primaryTransportMode: quoteDetails.summary.bookingTypeID === 19 ? 'A' : 'S',
            shipmentID: quoteDetails.summary.shipmentID,
            shipmentRef: quoteDetails.summary.shipmentRef
        };

        axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/shipmentquote/ConvertQuoteToShipment`, shipmentToQuoteReq)
            .then((res) => {
                if (res.status === 201) {
                    window.location.replace(`/LeoSeaPortal/bookingdetails?shipmentId=${res.data.shipmentId}`);
                }
            })
            .catch((error) => console.error(`An error occured whilst trying to convert a quote to a shipment with the error: ${error}`));
    };

    const documentOnClick = (document) => {
        if (document !== null) {
            if (document.stream) {
                openDocument(document);
            }
            else {
                axios
                    .get(`${process.env.REACT_APP_API_ENDPOINT}/api/attachment/GetAttachmentStream`, { params: { fileName: document.filename, location: document.location } })
                    .then((res) => {
                        if (res.data.length !== 0) {
                            document.stream = res.data;
                            openDocument(document);
                        }
                    })
                    .catch((e) => {
                        console.log('Attachment API error happened');
                    });
            }
        }
    }

    function openDocument(document) {
        const binaryString = window.atob(document.stream);
        const bytes = new Uint8Array(binaryString.length);
        const mappedData = bytes.map((byte, i) => binaryString.charCodeAt(i));
        const blob = new Blob([mappedData], { type: document.mediaType });
        const fileUrl = URL.createObjectURL(blob);
        window.open(fileUrl);
    }

    const handleDeleteDialogClose = () => {
        setQuoteTerminationRequest(null);
        setShowDeleteDialog(false);
    }

    const handleDeleteDialogOpen = () => {
        axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/shipmentQuote/GetQuoteLossReasonType`, { params: { bookingTypeId: quoteDetails.primaryTransportMode === 'S' ? 2 : 1 } })
            .then((res) => {
                setDeleteQuoteReasons(res.data);
                setShowDeleteQuoteReason(true);
            })
            .catch((error) => console.error(`An error occured whilst trying to get the Quote Loss Reason Type with the error: ${error}`));
    }

    const handleDeleteQuoteReasonClose = () => {
        setQuoteTerminationRequest(null);
        setShowDeleteQuoteReason(false);
    }

    const handleDeleteQuoteReasonOK = (deleteQuoteReason) => {
        setQuoteTerminationRequest({
            shipmentId: quoteDetails.summary.shipmentID,
            quoteLossReasonTypeID: deleteQuoteReason.quoteLossReasonTypeID,
            reasonForLostQuote: deleteQuoteReason.reasonForLostQuote
        });

        setShowDeleteQuoteReason(false);
        setShowDeleteDialog(true);
    }
    
    if(quoteDetailsLoading){
        return <LoadingSpinner />
    }
    return (
        <div style={{ position: 'relative', zIndex: '0' }}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Box sx={{ p: 2, display: 'flex' }}>
                            <Card>
                                <CardHeader style={{ backgroundColor: '#2059A7' }}>
                                <h4 className={classes.cardTitleWhite}>{quoteDetails.summary.isTerminated && <><WarningIcon /><i>(Terminated) </i></>}Quote Details Summary</h4>
                                </CardHeader>
                                <CardBody>
                                    {quoteDetails.summary.bookingTypeID === 19 && (<AirQuoteSummary quoteDetails={quoteDetails.summary}> </AirQuoteSummary>)}
                                    {quoteDetails.summary.bookingTypeID === 20 && (<SeaQuoteSummary quoteDetails={quoteDetails.summary}> </SeaQuoteSummary>)}
                                    <Accordion style={{ marginTop: "40px" }} defaultExpanded={true}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: darkBlueColor, color: "#fff" }}>
                                            <Typography>Quote Packages</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <table className='table table-striped' id="ShipmentSearch" aria-labelledby="tabelLabel">
                                                <thead>
                                                    <tr>
                                                        <th>Quantity</th>
                                                        <th>Type</th>
                                                        <th>Description</th>
                                                        <th>Total Gross Weight</th>
                                                        <th>Length</th>
                                                        <th>Width</th>
                                                        <th>Height</th>
                                                        <th>Volume</th>
                                                        <th>Stackable</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {quoteDetails.packages.map((item, i) =>
                                                        <tr key={`${item.packageID} - ${i}`}>
                                                            <td>{item.packageCount}</td>
                                                            <td>{item.packageTypeDescription}</td>
                                                            <td>{item.description}</td>
                                                            <td>{item.grossWeight}{"\n"}{item.measureUnitsGrossWeight}</td>
                                                            <td>{item.length}{"\n"}{item.measureUnitsLength}</td>
                                                            <td>{item.width}{"\n"}{item.measureUnitsWidth}</td>
                                                            <td>{item.height}{"\n"}{item.measureUnitsHeight}</td>
                                                            <td>{item.volume}{"\n"}{item.measureUnitsVolume}</td>
                                                            <td>{getDefaultStackMultiplier(item.stackMultiplier)}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion style={{ marginTop: "40px" }} defaultExpanded={true}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: darkBlueColor, color: "#fff" }}>
                                            <Typography>Documents</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <table className='table table-striped' id="ShipmentSearch" aria-labelledby="tabelLabel">
                                                <thead >
                                                    <tr>
                                                        <th>Document Type</th>
                                                        <th>Date Added</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {quoteDetails.attachments.map((item, i) =>
                                                        <tr key={`${item.attachmentID} - ${i}`}>
                                                            <td>{item.documentTypeDescription}</td>
                                                            <td>{new Date(item.dateAdded).toLocaleString()}</td>
                                                            <td align="right">
                                                                <a onClick={() => documentOnClick(item)}>
                                                                    <LaunchRoundedIcon style={{ cursor: 'pointer'}}></LaunchRoundedIcon>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </AccordionDetails>
                                    </Accordion>
                                    <GridItem>
                                        <br/>
                                        <p><em>* Currency exchange rates are calculated on the date of quotation and are subject to change.</em></p>
                                </GridItem>
                            </CardBody>
                            {!quoteDetails.summary.isTerminated &&
                                <CardFooter>
                                    {showAcceptButton && <Button color="purple" type="button" onClick={() => convertQuoteToShipment()}>Accept</Button>}
                                    {showDeleteQuoteReason &&
                                        <DeleteQuoteReason reasons={deleteQuoteReasons} handleDeleteQuoteReasonOK={handleDeleteQuoteReasonOK} handleDeleteQuoteReasonClose={handleDeleteQuoteReasonClose} />
                                    }
                                    {showDeleteButton &&
                                        <div>
                                            <Button color="purple" type="button" onClick={handleDeleteDialogOpen}>Decline</Button>
                                            <Dialog
                                                open={showDeleteDialog}
                                                onClose={handleDeleteDialogClose}
                                                aria-labelledby="alert-dialog-title"
                                                aria-describedby="alert-dialog-description"
                                            >
                                                <DialogTitle id="alert-dialog-title">Quote Termination</DialogTitle>
                                                <DialogContent>
                                                    <DialogContentText color='dark' id="alert-dialog-description">
                                                        This will terminate the quote. This can not be undone. Are you sure?
                                                    </DialogContentText>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button color="purple" onClick={terminateQuote}>Yes</Button>
                                                    <Button color="purple" onClick={handleDeleteDialogClose}>No</Button>
                                                </DialogActions>
                                            </Dialog>
                                        </div>
                                    }
                                </CardFooter>
                            }
                            </Card>
                        </Box>
                    </GridItem>
            </GridContainer>
        </div>
    );
}